import React from 'react';
import { ArcButton } from '@src/core/ui';
import { ArcSocketContext } from '@src/core/socket';
import { GoHomeActionProps } from './types';
import { EnRouteCommandEnum, EnRouteEventTypeEnum } from '@src/features/order/pages/take-off-to-en-route-page/entities';
import { useConfirm } from '@src/core/controllers/confirm-controller/hooks';
import { CommandStatusEnum } from '@src/features/order/entities';

const GoHomeAction: React.FC<GoHomeActionProps> = (props) => {
  const { serialNumber, resetGoHere } = props;
  const { arcSocket } = React.useContext(ArcSocketContext);
  const { confirm } = useConfirm();
  const [isLoading, setIsLoading] = React.useState(false);

  // Stop loading when websocket confirms DELIVERY_COMPLETED for this specific drone
  React.useEffect(() => {
    const socket = arcSocket();
    if (!socket || !serialNumber) return;

    const onMessage = (event: MessageEvent) => {
      try {
        const data = JSON.parse(event.data ?? '{}');
        
        if (data.type === 'COMMAND_STATUS') {
          
          // Only respond to DELIVERY_COMPLETED SUCCESS for this specific drone
          if (data?.command === CommandStatusEnum.DELIVERY_COMPLETED && 
              data?.status === 'SUCCESS' &&
              (data?.serialNumber === serialNumber || !data?.serialNumber)) {
            setIsLoading(false);
          }
        }
      } catch (_) {
        // ignore malformed messages
      }
    };

    socket.addEventListener('message', onMessage);
    return () => {
      socket.removeEventListener('message', onMessage);
    };
  }, [arcSocket, serialNumber]);

  // Cleanup loading state on unmount
  React.useEffect(() => {
    return () => {
      setIsLoading(false);
    };
  }, []);

  const goHome = async () => {
    const confirmed = await confirm(
      'The drone will fly to the home point via return route.',
      'Confirm Go Home?'
    );
    if (!confirmed) return;

    setIsLoading(true);
    const socket = arcSocket();
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.send(
        JSON.stringify({
          type: EnRouteEventTypeEnum.COMMAND,
          command: EnRouteCommandEnum.DELIVERY_COMPLETED,
          serialNumber,
        })
      );
      resetGoHere();
    }
  };

  return (
    <ArcButton.brand 
      sx={{ width: 200}} 
      // isLoading={isLoading}
      onClick={goHome}> 
      GO HOME
    </ArcButton.brand>
  );
};

export default GoHomeAction;